<div class="row" *ngIf="imageInfo['url']!=''">
    <div class="col-sm-12">
        <div class="card px-5 py-5 h-100  text-center">
           <img src="{{imageInfo['url']}}.png">
            <div class="pt-5">
                <a class="btn btn-primary mx-2" *ngIf="+id > 0" [routerLink]="['/info/gallery/preview',+id-1]"><i class="fa fa-angle-double-left"></i> Previous</a>
                <a class="btn btn-primary mx-2" *ngIf="+id == 0" [routerLink]="['/info/gallery/preview',21]"><i class="fa fa-angle-double-left"></i> Previous</a>
                <a class="btn btn-primary mx-2"  [routerLink]="['/info/gallery/preview']"><i class="fa fa-list"></i> Preview All</a>
                <a class="btn btn-primary mx-2" *ngIf="+id < 21" [routerLink]="['/info/gallery/preview',(+id+1)]"><i class="fa fa-angle-double-right"></i> Next</a>
                <a class="btn btn-primary mx-2" *ngIf="+id == 21" [routerLink]="['/info/gallery/preview',0]"><i class="fa fa-angle-double-right"></i> Next</a>
               
            </div>
        </div>
        
    </div>
</div>
